import { render, staticRenderFns } from "./porderList.vue?vue&type=template&id=2c59e7a8&scoped=true&"
import script from "./porderList.vue?vue&type=script&lang=js&"
export * from "./porderList.vue?vue&type=script&lang=js&"
import style0 from "./porderList.vue?vue&type=style&index=0&id=2c59e7a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c59e7a8",
  null
  
)

export default component.exports